
import React from 'react';
import { Button } from '@/components/ui/button';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
import { Attendee } from '@/types/attendee';
import ConfirmationDialog from './ConfirmationDialog';
import { useConfirmationDialog } from '@/hooks/admin/useConfirmationDialog';

interface UndoCheckInButtonProps {
  attendee: Attendee;
  isUpdating: boolean;
  onDirectUpdate: (code: string, updates: any) => Promise<any>;
}

const UndoCheckInButton: React.FC<UndoCheckInButtonProps> = ({
  attendee,
  isUpdating,
  onDirectUpdate
}) => {
  const isMobile = useIsMobile();
  const { isDialogOpen, openConfirmDialog, closeConfirmDialog, handleConfirm } = useConfirmationDialog();

  const handleUndoClick = () => {
    if (isUpdating) return;
    openConfirmDialog(async () => {
      const tShirtSize = attendee.t_shirt_size;
      
      if (onDirectUpdate) {
        await onDirectUpdate(attendee.code, {
          attended: false,
          checkedInAt: null,
          t_shirt_size: tShirtSize
        });
      }
    });
  };

  return (
    <>
      <Button
        variant="ghost"
        size={isMobile ? "icon" : "sm"}
        className="text-green-600 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
        onClick={handleUndoClick}
        disabled={isUpdating}
      >
        {isUpdating ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <CheckCircle className="h-5 w-5" />
        )}
        {!isMobile && <span className="ml-1">Hủy</span>}
      </Button>

      <ConfirmationDialog
        open={isDialogOpen}
        onOpenChange={closeConfirmDialog}
        onConfirm={handleConfirm}
        title="Xác nhận hủy điểm danh?"
        description={`Bạn có chắc chắn muốn hủy điểm danh cho ${attendee.name} không? Thao tác này sẽ đánh dấu người tham dự là chưa tham gia.`}
        icon={XCircle}
        iconColor="text-red-500"
        confirmText="Xác nhận hủy điểm danh"
        confirmButtonClass="bg-red-500 hover:bg-red-600"
        borderClass="border-red-300"
        backgroundClass=""
      />
    </>
  );
};

export default UndoCheckInButton;
